import { ChassisType, ChassisModelTypes, ChassisSeriesTypes, ChassisPassengerCapacities } from "../../../../../@types/ChassisType";
import assets from "../../../../../assets";

// X2 Specific Products
import {
    ChassisBatteryConfigs,
    ChassisBatteryConfigsPreassembly
} from "./X2Products/ChassisBatteryConfigs";
import SeatFrames from "./X2Products/SeatFrames";
import Tops from "./X2Products/Tops";

// Shared Products between XSeries Chassis
import { AccessoriesXSeries, AccessoriesXSeriesLifted, AccessoriesXSeriesOptional, AccessoriesXSeriesOptionalLifted, AccessoriesXSeriesOptionalNonLifted } from "../../Shared/Accessories";
import LugNuts from "../../Shared/LugNuts";
import WindShields from "../Shared/WindShields";
import Batteries from "../Shared/Batteries";
import { BodyColorsX2 } from "../Shared/BodyColors";
import { LiftKitsX2 } from "../Shared/LiftKit";
import { LsvKits_2024, LsvKits_2024Preassembled } from "./X2Products/LsvKits";
import { ColoradoDesignSolidFrontSeatsX2 } from "../Shared/Seats";
import {
    Tires12In,
    Tires12InLifted,
    Tires14In,
    Tires14InLifted,
    Tires15In,
    Tires15InLifted
} from "../Shared/Tires";
import {
    Wheels12InX2,
    Wheels14InX2,
    Wheels15InX2,
    WheelSizeOptions
} from "../Shared/Wheels";

export const X2: ChassisType = {
    id: `${ChassisModelTypes.X2}-2024`,
    sku: `${ChassisModelTypes.X2}-2024`,
    series: ChassisSeriesTypes.XSeries,
    categoryName: 'XSeries',
    name: '2024 XSeries X2 2 Passenger',
    year: 2024,
    model: ChassisModelTypes.X2,
    logo: assets.images.chassisLogo.x2,
    passengerCapacity: ChassisPassengerCapacities["2 Passenger"],
    price: 7210,
    retailPrice: 99999,
    marketingSlogan:
        `It’s not what you DRIVE. It’s how you drive.™`,
    bodyColorOptions: BodyColorsX2,
    liftKitOptions: LiftKitsX2,
    chassisBatteryConfigOptions: ChassisBatteryConfigs,
    chassisBatteryOptions: Batteries,
    wheelSizeOptions: WheelSizeOptions,
    wheelOptions: [
        ...Wheels12InX2,
        ...Wheels14InX2
    ],
    wheelOptionsLifted: [
        ...Wheels12InX2,
        ...Wheels14InX2,
        ...Wheels15InX2
    ],
    lugNutOptions: LugNuts,
    tireOptions: [
        ...Tires12In,
        ...Tires14In,
        ...Tires15In
    ],
    tireOptionsLifted: [
        ...Tires12InLifted,
        ...Tires14InLifted,
        ...Tires15InLifted
    ],
    lsvKitOptions: LsvKits_2024,
    topOptions: Tops,
    windshieldOptions: WindShields,
    frontSeatOptions: ColoradoDesignSolidFrontSeatsX2,
    seatFrameOptions: SeatFrames,
    preassembled: false,
    allowInternationalPurchase: true,
    inventoryOnlyProduct: true,
    includedAccessories: AccessoriesXSeries,
    includedAccessoriesLifted: AccessoriesXSeriesLifted,
    optionalAccessories: [...AccessoriesXSeriesOptional, ...AccessoriesXSeriesOptionalNonLifted],
    optionalAccessoriesLifted: AccessoriesXSeriesOptionalLifted
}

export const X2Assy: ChassisType = {
    ...X2,
    id: `${ChassisModelTypes.X2}-2024-Assy`,
    sku: `${ChassisModelTypes.X2}-2024-Assy`,
    price: 7510,
    preassembled: true,
    allowInternationalPurchase: false,
    lsvKitOptions: LsvKits_2024Preassembled,
    chassisBatteryConfigOptions: ChassisBatteryConfigsPreassembly
}